export const SET_APP = 'SET_APP'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_OPTIONS = 'SET_OPTIONS'
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_STATE = 'SET_STATE'
export const SET_CONFIGURATION = 'SET_CONFIGURATION'
export const SET_CACHE = 'SET_CACHE'
export const SET_FIRST = 'SET_FIRST'
